import { useSelector } from 'react-redux';

import PrivateRoute from 'containers/PrivateRoute';
import { canAccessMarketingCampaigns } from '../utils/marketingCampaignPermissions';

import SetupCheckerWrapper from './SetupCheckerWrapper';

const MarketingGeneralRoute = ({ children }) => {
    const isAllowed = useSelector(canAccessMarketingCampaigns);

    return (
        <PrivateRoute isAllowed={isAllowed} redirectTo="/">
            <SetupCheckerWrapper>{children}</SetupCheckerWrapper>
        </PrivateRoute>
    );
};

export default MarketingGeneralRoute;
